import Home from '../pages/Home'
import Works from '../pages/Works'
import Blog from '../pages/Blog'

export default [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/works',
    name: 'Works',
    component: Works
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog
  },
]